import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';

// ─── Constantes ───────────────────────────────────────────────────────────────

const STATUTS_COMMANDE = {
  attente_info:       { label: 'Attente infos',      color: '#856404', bg: '#fff3cd', border: '#ffc107' },
  bat_en_cours:       { label: 'BAT en cours',        color: '#0c5460', bg: '#d1ecf1', border: '#17a2b8' },
  production_en_cours:{ label: 'Production en cours', color: '#155724', bg: '#d4edda', border: '#28a745' },
  expediee:           { label: 'Expédiée',            color: '#ffffff', bg: '#003189', border: '#003189' },
};

const STATUTS_LIGNE = {
  attente_infos:          { label: 'Attente infos',         color: '#856404', bg: '#fff3cd' },
  bat_a_faire:            { label: 'BAT à faire',           color: '#6f42c1', bg: '#f0e6ff' },
  bat_attente_validation: { label: 'BAT attente validation',color: '#0c5460', bg: '#d1ecf1' },
  bat_valide:             { label: 'BAT validé',            color: '#155724', bg: '#d4edda' },
};

const badgeStatutCommande = (statut) => {
  const s = STATUTS_COMMANDE[statut] || STATUTS_COMMANDE.attente_info;
  return (
    <span style={{
      fontSize: '11px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px',
      backgroundColor: s.bg, color: s.color, border: `1px solid ${s.border}`
    }}>
      {s.label}
    </span>
  );
};

const badgeStatutLigne = (statut) => {
  const s = STATUTS_LIGNE[statut] || STATUTS_LIGNE.attente_infos;
  return (
    <span style={{
      fontSize: '11px', fontWeight: '600', padding: '2px 8px', borderRadius: '20px',
      backgroundColor: s.bg, color: s.color
    }}>
      {s.label}
    </span>
  );
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// Helper envoi email : console.log en dev, vraie API en production
const sendEmail = async ({ to, subject, html }) => {
  const isDev = process.env.NODE_ENV === 'development';
  if (isDev) {
    console.log('%c📧 [DEV] Email simulé', 'color: #003189; font-weight: bold;');
    console.log('  → À :', to);
    console.log('  → Sujet :', subject);
    console.log('  → Corps HTML :', html);
    return;
  }
  await fetch('/api/send-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ to, subject, html })
  });
};

// Templates email
const emailTemplatePilote = ({ prenomNom, produitLabel, numeroVersion, lien }) => `
<!DOCTYPE html><html><head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#f4f4f4;font-family:Arial,sans-serif">
<table width="100%" cellpadding="0" cellspacing="0"><tr><td align="center" style="padding:40px 20px">
<table width="600" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:12px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,0.08)">
  <tr><td style="background:#003189;padding:24px 40px;text-align:center">
    <table cellpadding="0" cellspacing="0" style="margin:0 auto 16px"><tr>
      <td style="vertical-align:middle;padding-right:12px"><img src="https://factorylab3d.com/Image/Logo%20FFM%20blanc.png" alt="FFM" style="height:40px;display:block"></td>
      <td style="vertical-align:middle;padding-right:12px"><span style="color:rgba(255,255,255,0.7);font-size:13px;font-family:Arial,sans-serif">Custom Lab FFM by</span></td>
      <td style="vertical-align:middle"><img src="https://factorylab3d.com/Image/Logo%20Impulse%20blanc.svg" alt="Impulse" style="height:24px;display:block"></td>
    </tr></table>
    <h1 style="color:#ffffff;margin:0;font-size:22px;font-weight:700">Votre maquette est disponible</h1>
    <p style="color:rgba(255,255,255,0.8);margin:8px 0 0;font-size:14px">Pour consultation uniquement</p>
  </td></tr>
  <tr><td style="padding:40px">
    <p style="font-size:15px;color:#212529;margin:0 0 16px">Bonjour <strong>${prenomNom}</strong>,</p>
    <p style="font-size:15px;color:#495057;margin:0 0 24px;line-height:1.6">
      La maquette <strong>version ${numeroVersion}</strong> est disponible pour votre commande :<br>
      <strong style="color:#003189">${produitLabel}</strong>
    </p>
    <p style="font-size:14px;color:#495057;margin:0 0 32px;line-height:1.6">
      Vous pouvez la consulter en cliquant sur le lien ci-dessous. La validation est assurée par votre opérateur FFM.
    </p>
    <table cellpadding="0" cellspacing="0"><tr><td style="background:#003189;border-radius:8px">
      <a href="${lien}" style="display:inline-block;padding:16px 32px;color:#ffffff;text-decoration:none;font-size:15px;font-weight:700">
        Voir ma maquette →
      </a>
    </td></tr></table>
    <p style="font-size:12px;color:#adb5bd;margin:24px 0 0">
      Ce lien est personnel et à usage unique.
    </p>
  </td></tr>
  <tr><td style="background:#f8f9fa;padding:20px 40px;text-align:center;border-top:1px solid #e9ecef">
    <p style="font-size:12px;color:#adb5bd;margin:0">Fédération Française de Motocyclisme — Personnalisation des équipes de France</p>
  </td></tr>
</table>
</td></tr></table>
</body></html>`;

const emailTemplateOperateurValidation = ({ prenomNom, produitLabel, piloteNom, numeroVersion, lien }) => `
<!DOCTYPE html><html><head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#f4f4f4;font-family:Arial,sans-serif">
<table width="100%" cellpadding="0" cellspacing="0"><tr><td align="center" style="padding:40px 20px">
<table width="600" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:12px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,0.08)">
  <tr><td style="background:#003189;padding:24px 40px;text-align:center">
    <table cellpadding="0" cellspacing="0" style="margin:0 auto 16px"><tr>
      <td style="vertical-align:middle;padding-right:12px"><img src="https://factorylab3d.com/Image/Logo%20FFM%20blanc.png" alt="FFM" style="height:40px;display:block"></td>
      <td style="vertical-align:middle;padding-right:12px"><span style="color:rgba(255,255,255,0.7);font-size:13px;font-family:Arial,sans-serif">Custom Lab FFM by</span></td>
      <td style="vertical-align:middle"><img src="https://factorylab3d.com/Image/Logo%20Impulse%20blanc.svg" alt="Impulse" style="height:24px;display:block"></td>
    </tr></table>
    <h1 style="color:#ffffff;margin:0;font-size:22px;font-weight:700">Votre validation est requise</h1>
    <p style="color:rgba(255,255,255,0.8);margin:8px 0 0;font-size:14px">1ère validation — Opérateur FFM</p>
  </td></tr>
  <tr><td style="padding:40px">
    <p style="font-size:15px;color:#212529;margin:0 0 16px">Bonjour <strong>${prenomNom}</strong>,</p>
    <p style="font-size:15px;color:#495057;margin:0 0 24px;line-height:1.6">
      Un BAT <strong>version ${numeroVersion}</strong> vient d'être soumis pour le pilote <strong>${piloteNom}</strong> :<br>
      <strong style="color:#003189">${produitLabel}</strong>
    </p>
    <p style="font-size:14px;color:#495057;margin:0 0 32px;line-height:1.6">
      Votre validation est requise en tant qu'opérateur FFM de cette ligne. Consultez le BAT et approuvez-le ou demandez des modifications.
    </p>
    <table cellpadding="0" cellspacing="0"><tr><td style="background:#003189;border-radius:8px">
      <a href="${lien}" style="display:inline-block;padding:16px 32px;color:#ffffff;text-decoration:none;font-size:15px;font-weight:700">
        Valider le BAT →
      </a>
    </td></tr></table>
    <p style="font-size:12px;color:#adb5bd;margin:24px 0 0">Ce lien est personnel et à usage unique.</p>
  </td></tr>
  <tr><td style="background:#f8f9fa;padding:20px 40px;text-align:center;border-top:1px solid #e9ecef">
    <p style="font-size:12px;color:#adb5bd;margin:0">Fédération Française de Motocyclisme — Personnalisation des équipes de France</p>
  </td></tr>
</table>
</td></tr></table>
</body></html>`;

// Calcule le statut global d'une commande en fonction de ses lignes
const calculerStatutCommande = (lignes) => {
  if (!lignes || lignes.length === 0) return 'attente_info';
  if (lignes.every(l => l.statut === 'bat_valide')) return 'production_en_cours';
  if (lignes.every(l => l.statut !== 'attente_infos')) return 'bat_en_cours';
  return 'attente_info';
};

// ─── Styles réutilisables ─────────────────────────────────────────────────────

const styleBtnPrimary = {
  padding: '10px 20px', backgroundColor: '#003189', color: '#ffffff',
  border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px'
};
const styleBtnSecondary = {
  padding: '8px 16px', backgroundColor: 'transparent', color: '#6c757d',
  border: '1px solid #dee2e6', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500'
};
const styleInput = {
  width: '100%', padding: '10px 14px', border: '1px solid #dee2e6',
  borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box'
};
const styleLabel = {
  display: 'block', fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px'
};

// ─────────────────────────────────────────────────────────────────────────────

function FFMCommandes() {
  // ── State principal ────────────────────────────────────────────────────────
  const [commandes, setCommandes]         = useState([]);
  const [commandeActive, setCommandeActive] = useState(null); // commande ouverte en détail
  const [lignes, setLignes]               = useState([]);
  const [produits, setProduits]           = useState([]);
  const [pilotes, setPilotes]             = useState([]);
  const [operateursBack, setOperateursBack] = useState([]); // opérateurs FFM
  const [loading, setLoading]             = useState(true);
  const [loadingLignes, setLoadingLignes] = useState(false);

  // ── Modals ────────────────────────────────────────────────────────────────
  const [showModalCommande, setShowModalCommande] = useState(false);
  const [editingCommande, setEditingCommande]     = useState(null);
  const [showModalLigne, setShowModalLigne]       = useState(false);
  const [editingLigne, setEditingLigne]           = useState(null);

  // ── Modals BAT ────────────────────────────────────────────────────────────
  const [showModalInfosBAT, setShowModalInfosBAT]   = useState(false);
  const [ligneInfosBAT, setLigneInfosBAT]           = useState(null);
  const [formInfosBAT, setFormInfosBAT]             = useState({ description: '' });
  const [fichiersInfosBAT, setFichiersInfosBAT]     = useState([]); // pièces jointes
  const [piecesJointesExistantes, setPiecesJointesExistantes] = useState([]); // urls déjà en base
  const [readOnlyInfosBAT, setReadOnlyInfosBAT]     = useState(false); // lecture seule si figé
  const [erreurInfosBAT, setErreurInfosBAT]         = useState('');
  const [submittingInfosBAT, setSubmittingInfosBAT] = useState(false);

  const [showModalUploadBAT, setShowModalUploadBAT] = useState(false);
  const [ligneUploadBAT, setLigneUploadBAT]         = useState(null);
  const [fichierBAT, setFichierBAT]                 = useState(null);
  const [erreurUploadBAT, setErreurUploadBAT]       = useState('');
  const [uploadingBAT, setUploadingBAT]             = useState(false);

  const [showModalHistorique, setShowModalHistorique] = useState(false);
  const [ligneHistorique, setLigneHistorique]         = useState(null);
  const [historique, setHistorique]                   = useState([]);
  const [loadingHistorique, setLoadingHistorique]     = useState(false);

  // ── Expédition ────────────────────────────────────────────────────────────
  const [showModalExpedition, setShowModalExpedition] = useState(false);
  const [numeroSuivi, setNumeroSuivi]                 = useState('');
  const [erreurExpedition, setErreurExpedition]       = useState('');
  const [submittingExpedition, setSubmittingExpedition] = useState(false);

  // ── Formulaires ───────────────────────────────────────────────────────────
  const [formCommande, setFormCommande] = useState({
    nom: '', nom_course: '', date_course: '', adresse_entreprise: '', adresse_nom: '', adresse_prenom: '', adresse_rue: '', adresse_cp: '', adresse_ville: '', responsable_validation_id: ''
  });
  const [formLigne, setFormLigne] = useState({
    produit_id: '', pilote_id: '', operateur_nom: '', operateur_ffm_id: '', option_valeur: '', quantite: 1
  });
  const [erreurCommande, setErreurCommande] = useState('');
  const [erreurLigne, setErreurLigne]       = useState('');

  // ── Chargement initial ────────────────────────────────────────────────────
  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    setLoading(true);
    const [
      { data: cmds },
      { data: prods },
      { data: pils },
      { data: ops }
    ] = await Promise.all([
      supabase.from('ffm_commandes').select('*, ffm_lignes_produit(id, statut)').order('date_creation', { ascending: false }),
      supabase.from('ffm_produits').select('id, nom, option_nom, option_valeurs').eq('actif', true).order('nom'),
      supabase.from('ffm_pilotes').select('id, prenom, nom').order('nom'),
      supabase.from('ffm_operateurs').select('id, prenom, nom, email').eq('actif', true).order('nom')
    ]);
    setCommandes(cmds || []);
    setProduits(prods || []);
    setPilotes(pils || []);
    setOperateursBack(ops || []);
    setLoading(false);
  };

  const loadLignes = useCallback(async (commandeId) => {
    setLoadingLignes(true);
    const { data, error } = await supabase
      .from('ffm_lignes_produit')
      .select('*, ffm_pilotes(id, prenom, nom, email), ffm_bat_infos(description, pieces_jointes, fige), ffm_operateurs(id, prenom, nom, email)')
      .eq('commande_id', commandeId)
      .order('date_creation', { ascending: true });
    if (error) console.error(error);
    setLignes(data || []);
    setLoadingLignes(false);
  }, []);

  // Quand on ouvre une commande en détail
  const ouvrirCommande = async (commande) => {
    setCommandeActive(commande);
    await loadLignes(commande.id);
  };

  const fermerCommande = () => {
    setCommandeActive(null);
    setLignes([]);
  };

  // ── Mise à jour statut commande automatique ────────────────────────────────
  const mettreAJourStatutCommande = async (commandeId, nouvellesLignes) => {
    const nouveauStatut = calculerStatutCommande(nouvellesLignes);
    // Ne pas écraser 'expediee' automatiquement
    const cmdActuelle = commandes.find(c => c.id === commandeId);
    if (cmdActuelle?.statut === 'expediee') return;

    await supabase.from('ffm_commandes').update({ statut: nouveauStatut }).eq('id', commandeId);
    setCommandes(prev => prev.map(c =>
      c.id === commandeId ? { ...c, statut: nouveauStatut } : c
    ));
    if (commandeActive?.id === commandeId) {
      setCommandeActive(prev => ({ ...prev, statut: nouveauStatut }));
    }
  };

  // ── CRUD Commande ─────────────────────────────────────────────────────────
  const openModalCommande = (commande = null) => {
    setErreurCommande('');
    if (commande) {
      setEditingCommande(commande);
      setFormCommande({
        nom: commande.nom,
        nom_course: commande.nom_course,
        date_course: commande.date_course || '',
        adresse_entreprise: commande.adresse_entreprise || '',
        adresse_nom: commande.adresse_nom || '',
        adresse_prenom: commande.adresse_prenom || '',
        adresse_rue: commande.adresse_rue || '',
        adresse_cp: commande.adresse_cp || '',
        adresse_ville: commande.adresse_ville || '',
        responsable_validation_id: commande.responsable_validation_id || ''
      });
    } else {
      setEditingCommande(null);
      setFormCommande({ nom: '', nom_course: '', date_course: '', adresse_entreprise: '', adresse_prenom: '', adresse_nom: '', adresse_rue: '', adresse_cp: '', adresse_ville: '', responsable_validation_id: '' });
    }
    setShowModalCommande(true);
  };

  const closeModalCommande = () => {
    setShowModalCommande(false);
    setEditingCommande(null);
    setErreurCommande('');
  };

  const handleSubmitCommande = async (e) => {
    e.preventDefault();
    setErreurCommande('');
    if (!formCommande.nom.trim()) { setErreurCommande('La référence de la commande est obligatoire.'); return; }
    if (!formCommande.nom_course.trim()) { setErreurCommande('Le nom de la course est obligatoire.'); return; }

    const payload = {
      nom: formCommande.nom.trim(),
      nom_course: formCommande.nom_course.trim(),
      date_course: formCommande.date_course || null,
      adresse_entreprise: formCommande.adresse_entreprise?.trim() || null,
      adresse_nom: formCommande.adresse_nom?.trim() || null,
      adresse_prenom: formCommande.adresse_prenom?.trim() || null,
      adresse_rue: formCommande.adresse_rue?.trim() || null,
      adresse_cp: formCommande.adresse_cp?.trim() || null,
      adresse_ville: formCommande.adresse_ville?.trim() || null,
      responsable_validation_id: formCommande.responsable_validation_id || null
    };

    if (editingCommande) {
      const { error } = await supabase.from('ffm_commandes').update(payload).eq('id', editingCommande.id);
      if (error) { setErreurCommande('Erreur lors de la modification.'); return; }
      if (commandeActive?.id === editingCommande.id) {
        setCommandeActive(prev => ({ ...prev, ...payload }));
      }
    } else {
      const { data, error } = await supabase.from('ffm_commandes').insert([payload]).select().single();
      if (error) { setErreurCommande('Erreur lors de la création.'); return; }
      // Ouvrir automatiquement la commande créée
      await loadAll();
      closeModalCommande();
      await ouvrirCommande({ ...payload, ...data, ffm_lignes_produit: [] });
      return;
    }

    await loadAll();
    closeModalCommande();
  };

  // ── CRUD Ligne produit ────────────────────────────────────────────────────
  const openModalLigne = (ligne = null) => {
    setErreurLigne('');
    if (ligne) {
      setEditingLigne(ligne);
      setFormLigne({
        produit_id: ligne.produit_id || '',
        pilote_id: ligne.pilote_id || '',
        operateur_nom: ligne.operateur_nom || '',
        operateur_ffm_id: ligne.operateur_ffm_id || '',
        option_valeur: ligne.option_valeur || '',
        quantite: ligne.quantite
      });
    } else {
      setEditingLigne(null);
      setFormLigne({ produit_id: '', pilote_id: '', operateur_nom: '', operateur_ffm_id: '', option_valeur: '', quantite: 1 });
    }
    setShowModalLigne(true);
  };

  const closeModalLigne = () => {
    setShowModalLigne(false);
    setEditingLigne(null);
    setErreurLigne('');
  };

  const produitSelectionne = produits.find(p => p.id === formLigne.produit_id);

  const handleSubmitLigne = async (e) => {
    e.preventDefault();
    setErreurLigne('');
    if (!formLigne.produit_id) { setErreurLigne('Sélectionnez un produit.'); return; }
    if (!formLigne.pilote_id)  { setErreurLigne('Sélectionnez un pilote.'); return; }
    if (produitSelectionne?.option_nom && !formLigne.option_valeur) {
      setErreurLigne(`Sélectionnez une valeur pour l'option "${produitSelectionne.option_nom}".`); return;
    }
    if (!formLigne.quantite || formLigne.quantite < 1) { setErreurLigne('La quantité doit être ≥ 1.'); return; }

    const payload = {
      commande_id: commandeActive.id,
      produit_id: formLigne.produit_id,
      produit_nom: produitSelectionne?.nom || '',
      pilote_id: formLigne.pilote_id,
      operateur_nom: formLigne.operateur_nom || null,
      operateur_ffm_id: formLigne.operateur_ffm_id || null,
      option_valeur: formLigne.option_valeur || null,
      quantite: parseInt(formLigne.quantite, 10)
    };

    if (editingLigne) {
      const { error } = await supabase.from('ffm_lignes_produit').update(payload).eq('id', editingLigne.id);
      if (error) { setErreurLigne('Erreur lors de la modification.'); return; }
    } else {
      const { error } = await supabase.from('ffm_lignes_produit').insert([{ ...payload, statut: 'attente_infos' }]);
      if (error) { setErreurLigne('Erreur lors de la création.'); return; }
    }

    await loadLignes(commandeActive.id);
    // Recharger les lignes pour recalculer le statut
    const { data: lignesUpdated } = await supabase
      .from('ffm_lignes_produit').select('statut').eq('commande_id', commandeActive.id);
    await mettreAJourStatutCommande(commandeActive.id, lignesUpdated || []);
    closeModalLigne();
  };

  const handleDeleteLigne = async (ligneId) => {
    if (!window.confirm('Supprimer cette ligne produit ?')) return;
    await supabase.from('ffm_lignes_produit').delete().eq('id', ligneId);
    await loadLignes(commandeActive.id);
    const { data: lignesUpdated } = await supabase
      .from('ffm_lignes_produit').select('statut').eq('commande_id', commandeActive.id);
    await mettreAJourStatutCommande(commandeActive.id, lignesUpdated || []);
  };

  // ── Envoyer infos BAT ─────────────────────────────────────────────────────
  const openModalInfosBAT = async (ligne) => {
    setLigneInfosBAT(ligne);
    setErreurInfosBAT('');
    setFichiersInfosBAT([]);
    setPiecesJointesExistantes([]);
    // Utiliser les données déjà chargées via la jointure
    const batInfos = ligne.ffm_bat_infos;
    const fige = batInfos?.fige || false;
    setReadOnlyInfosBAT(fige);
    setFormInfosBAT({ description: batInfos?.description || '' });
    setPiecesJointesExistantes(batInfos?.pieces_jointes || []);
    setShowModalInfosBAT(true);
  };

  const closeModalInfosBAT = () => {
    setShowModalInfosBAT(false);
    setLigneInfosBAT(null);
    setFichiersInfosBAT([]);
    setPiecesJointesExistantes([]);
    setReadOnlyInfosBAT(false);
    setErreurInfosBAT('');
  };

  const handleSubmitInfosBAT = async (e) => {
    e.preventDefault();
    setErreurInfosBAT('');
    if (!formInfosBAT.description.trim()) {
      setErreurInfosBAT('La description est obligatoire.'); return;
    }
    setSubmittingInfosBAT(true);
    try {
      // Upload des pièces jointes si présentes
      const urlsPiecesJointes = [];
      for (const fichier of fichiersInfosBAT) {
        const path = `infos/${ligneInfosBAT.id}/${Date.now()}_${fichier.name.replace(/\s+/g, '_')}`;
        const { error: errUpload } = await supabase.storage.from('ffm').upload(path, fichier);
        if (errUpload) throw errUpload;
        const { data: urlData } = supabase.storage.from('ffm').getPublicUrl(path);
        urlsPiecesJointes.push(urlData.publicUrl);
      }

      // Récupérer les pièces jointes existantes pour les conserver
      const existingUrls = piecesJointesExistantes;

      // Upsert ffm_bat_infos
      const { error: errInfos } = await supabase
        .from('ffm_bat_infos')
        .upsert({
          ligne_produit_id: ligneInfosBAT.id,
          description: formInfosBAT.description.trim(),
          pieces_jointes: [...existingUrls, ...urlsPiecesJointes],
          fige: false
        }, { onConflict: 'ligne_produit_id' });
      if (errInfos) throw errInfos;

      // Mettre à jour le statut de la ligne → bat_a_faire
      await supabase.from('ffm_lignes_produit')
        .update({ statut: 'bat_a_faire' })
        .eq('id', ligneInfosBAT.id);

      // Enregistrer dans l'historique
      await supabase.from('ffm_bat_historique').insert([{
        ligne_produit_id: ligneInfosBAT.id,
        type_evenement: 'infos_envoyees',
        auteur: 'Backoffice',
        auteur_type: 'operateur_backoffice',
        commentaire: formInfosBAT.description.trim(),
        pieces_jointes: urlsPiecesJointes
      }]);

      await loadLignes(commandeActive.id);
      const { data: lignesUpdated } = await supabase
        .from('ffm_lignes_produit').select('statut').eq('commande_id', commandeActive.id);
      await mettreAJourStatutCommande(commandeActive.id, lignesUpdated || []);
      closeModalInfosBAT();
    } catch (err) {
      console.error(err);
      setErreurInfosBAT('Erreur lors de l\'enregistrement : ' + (err.message || 'inconnue'));
    } finally {
      setSubmittingInfosBAT(false);
    }
  };

  // ── Upload BAT ────────────────────────────────────────────────────────────
  const openModalUploadBAT = (ligne) => {
    setLigneUploadBAT(ligne);
    setFichierBAT(null);
    setErreurUploadBAT('');
    setShowModalUploadBAT(true);
  };

  const closeModalUploadBAT = () => {
    setShowModalUploadBAT(false);
    setLigneUploadBAT(null);
    setFichierBAT(null);
    setErreurUploadBAT('');
  };

  const handleSubmitUploadBAT = async (e) => {
    e.preventDefault();
    setErreurUploadBAT('');
    if (!fichierBAT) { setErreurUploadBAT('Sélectionnez un fichier.'); return; }

    setUploadingBAT(true);
    try {
      // Calculer le numéro de version
      const { count } = await supabase
        .from('ffm_bat_versions')
        .select('*', { count: 'exact', head: true })
        .eq('ligne_produit_id', ligneUploadBAT.id);
      const numeroVersion = (count || 0) + 1;

      // Upload vers Supabase Storage (bucket ffm)
      const ext = fichierBAT.name.split('.').pop();
      const path = `bat/${ligneUploadBAT.id}/v${numeroVersion}/${Date.now()}.${ext}`;
      const { error: errUpload } = await supabase.storage.from('ffm').upload(path, fichierBAT);
      if (errUpload) throw errUpload;

      // URL publique
      const { data: urlData } = supabase.storage.from('ffm').getPublicUrl(path);
      const fichierUrl = urlData.publicUrl;

      // Créer la version BAT
      const { data: version, error: errVersion } = await supabase
        .from('ffm_bat_versions')
        .insert([{
          ligne_produit_id: ligneUploadBAT.id,
          numero_version: numeroVersion,
          fichier_url: fichierUrl,
          statut: 'en_attente'
        }])
        .select().single();
      if (errVersion) throw errVersion;

      // Figer ffm_bat_infos si 1ère version
      if (numeroVersion === 1) {
        await supabase.from('ffm_bat_infos')
          .update({ fige: true })
          .eq('ligne_produit_id', ligneUploadBAT.id);
      }

      // Mettre à jour statut ligne → bat_attente_validation
      await supabase.from('ffm_lignes_produit')
        .update({ statut: 'bat_attente_validation' })
        .eq('id', ligneUploadBAT.id);

      // Historique
      await supabase.from('ffm_bat_historique').insert([{
        ligne_produit_id: ligneUploadBAT.id,
        version_id: version.id,
        type_evenement: 'bat_uploade',
        auteur: 'Backoffice',
        auteur_type: 'graphiste',
        commentaire: `Version ${numeroVersion} uploadée`
      }]);

      // ── Création des tokens + envoi emails ───────────────────────────────
      // Récupérer les infos email nécessaires
      const { data: ligneComplete } = await supabase
        .from('ffm_lignes_produit')
        .select('produit_nom, option_valeur, ffm_pilotes(prenom, nom, email), ffm_operateurs(prenom, nom, email)')
        .eq('id', ligneUploadBAT.id)
        .single();

      const pilote = ligneComplete?.ffm_pilotes;
      const operateurFFM = ligneComplete?.ffm_operateurs;
      const baseUrl = window.location.origin;
      const produitLabel = ligneComplete?.option_valeur
        ? `${ligneComplete.produit_nom} — ${ligneComplete.option_valeur}`
        : ligneComplete?.produit_nom || '';
      const piloteNom = pilote ? `${pilote.prenom} ${pilote.nom}` : '';

      // ── Token pilote (consultation uniquement) ───────────────────────────
      if (pilote?.email) {
        const { data: tokenPilote } = await supabase
          .from('ffm_bat_tokens')
          .insert([{
            version_id: version.id,
            type: 'pilote',
            email: pilote.email,
            nom_destinataire: `${pilote.prenom} ${pilote.nom}`,
            statut: 'en_attente',
            bloque: false
          }])
          .select('token').single();

        if (tokenPilote?.token) {
          const lienPilote = `${baseUrl}/ffm/bat/${tokenPilote.token}`;
          await sendEmail({
            to: pilote.email,
            subject: `[FFM] Votre maquette est disponible — ${produitLabel}`,
            html: emailTemplatePilote({
              prenomNom: `${pilote.prenom} ${pilote.nom}`,
              produitLabel,
              numeroVersion,
              lien: lienPilote,
            })
          });
        }
      }

      // ── Token opérateur FFM ligne (1ère validation, direct) ─────────────
      if (operateurFFM?.email) {
        const { data: tokenOp } = await supabase
          .from('ffm_bat_tokens')
          .insert([{
            version_id: version.id,
            type: 'operateur',
            email: operateurFFM.email,
            nom_destinataire: `${operateurFFM.prenom} ${operateurFFM.nom}`,
            statut: 'en_attente',
            bloque: false
          }])
          .select('token').single();

        if (tokenOp?.token) {
          const lienOp = `${baseUrl}/ffm/bat/${tokenOp.token}`;
          await sendEmail({
            to: operateurFFM.email,
            subject: `[FFM] Validation requise — ${produitLabel}`,
            html: emailTemplateOperateurValidation({
              prenomNom: `${operateurFFM.prenom} ${operateurFFM.nom}`,
              produitLabel,
              piloteNom,
              numeroVersion,
              lien: lienOp,
            })
          });
        }
      }

      // ── Token responsable validation finale (bloqué jusqu'à validation op) ──
      const responsableId = commandeActive.responsable_validation_id;
      if (responsableId) {
        const responsable = operateursBack.find(o => o.id === responsableId);
        if (responsable?.email) {
          await supabase
            .from('ffm_bat_tokens')
            .insert([{
              version_id: version.id,
              type: 'responsable',
              email: responsable.email,
              nom_destinataire: `${responsable.prenom} ${responsable.nom}`,
              statut: 'en_attente',
              bloque: true
            }]);
          // Email envoyé uniquement quand l'opérateur FFM valide
        }
      }

      await loadLignes(commandeActive.id);
      const { data: lignesUpdated } = await supabase
        .from('ffm_lignes_produit').select('statut').eq('commande_id', commandeActive.id);
      await mettreAJourStatutCommande(commandeActive.id, lignesUpdated || []);
      closeModalUploadBAT();
    } catch (err) {
      console.error(err);
      setErreurUploadBAT('Erreur lors de l\'upload : ' + (err.message || 'inconnue'));
    } finally {
      setUploadingBAT(false);
    }
  };

  // ── Historique BAT ────────────────────────────────────────────────────────
  const ouvrirHistorique = async (ligne) => {
    setLigneHistorique(ligne);
    setLoadingHistorique(true);
    setShowModalHistorique(true);
    const { data } = await supabase
      .from('ffm_bat_historique')
      .select('*, ffm_bat_versions(numero_version, fichier_url, ffm_bat_tokens(type, token, statut, bloque, nom_destinataire))')
      .eq('ligne_produit_id', ligne.id)
      .order('date_evenement', { ascending: true });
    setHistorique(data || []);
    setLoadingHistorique(false);
  };

  const fermerHistorique = () => {
    setShowModalHistorique(false);
    setLigneHistorique(null);
    setHistorique([]);
  };

  // ── Expédition ────────────────────────────────────────────────────────────
  const handleExpedier = async () => {
    if (!numeroSuivi.trim()) {
      setErreurExpedition('Veuillez saisir un numéro de suivi.');
      return;
    }
    setErreurExpedition('');
    setSubmittingExpedition(true);
    try {
      await supabase
        .from('ffm_commandes')
        .update({
          statut: 'expediee',
          numero_suivi: numeroSuivi.trim(),
          date_expedition: new Date().toISOString()
        })
        .eq('id', commandeActive.id);
      setCommandeActive(prev => ({ ...prev, statut: 'expediee', numero_suivi: numeroSuivi.trim(), date_expedition: new Date().toISOString() }));
      setCommandes(prev => prev.map(c =>
        c.id === commandeActive.id ? { ...c, statut: 'expediee', numero_suivi: numeroSuivi.trim() } : c
      ));
      setShowModalExpedition(false);
      setNumeroSuivi('');
    } catch (err) {
      setErreurExpedition('Erreur lors de l\'enregistrement.');
    } finally {
      setSubmittingExpedition(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // VUE DÉTAIL D'UNE COMMANDE
  // ─────────────────────────────────────────────────────────────────────────
  if (commandeActive) {
    return (
      <div>
        {/* Fil d'ariane */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
          <button
            onClick={fermerCommande}
            style={{ ...styleBtnSecondary, padding: '6px 14px', fontSize: '13px' }}
          >
            ← Commandes
          </button>
          <span style={{ color: '#adb5bd', fontSize: '14px' }}>›</span>
          <span style={{ fontWeight: '700', fontSize: '15px', color: '#212529' }}>{commandeActive.nom}</span>
          <span style={{ marginLeft: '8px' }}>{badgeStatutCommande(commandeActive.statut)}</span>
        </div>

        {/* Infos commande */}
        <div style={{
          backgroundColor: '#f8f9fa', borderRadius: '12px', padding: '18px 22px',
          marginBottom: '24px', border: '1px solid #e9ecef',
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px'
        }}>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#adb5bd', textTransform: 'uppercase', marginBottom: '4px' }}>Course</div>
            <div style={{ fontWeight: '600', color: '#212529' }}>{commandeActive.nom_course}</div>
          </div>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#adb5bd', textTransform: 'uppercase', marginBottom: '4px' }}>Date de la course</div>
            <div style={{ fontWeight: '600', color: '#212529' }}>{formatDate(commandeActive.date_course)}</div>
          </div>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#adb5bd', textTransform: 'uppercase', marginBottom: '4px' }}>Adresse de livraison</div>
            <div style={{ fontWeight: '600', color: '#212529', lineHeight: '1.6' }}>
              {(commandeActive.adresse_entreprise || commandeActive.adresse_nom || commandeActive.adresse_prenom || commandeActive.adresse_rue) ? (
                <>
                  {commandeActive.adresse_entreprise && <div>{commandeActive.adresse_entreprise}</div>}
                  {(commandeActive.adresse_prenom || commandeActive.adresse_nom) && (
                    <div>{[commandeActive.adresse_prenom, commandeActive.adresse_nom].filter(Boolean).join(' ')}</div>
                  )}
                  {commandeActive.adresse_rue && <div>{commandeActive.adresse_rue}</div>}
                  {(commandeActive.adresse_cp || commandeActive.adresse_ville) && (
                    <div>{[commandeActive.adresse_cp, commandeActive.adresse_ville].filter(Boolean).join(' ')}</div>
                  )}
                </>
              ) : '—'}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#adb5bd', textTransform: 'uppercase', marginBottom: '4px' }}>Créée le</div>
            <div style={{ fontWeight: '600', color: '#212529' }}>{formatDate(commandeActive.date_creation)}</div>
          </div>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#adb5bd', textTransform: 'uppercase', marginBottom: '4px' }}>Responsable validation</div>
            <div style={{ fontWeight: '600', color: commandeActive.responsable_validation_id ? '#212529' : '#dc3545' }}>
              {commandeActive.responsable_validation_id
                ? (() => { const r = operateursBack.find(o => o.id === commandeActive.responsable_validation_id); return r ? `${r.prenom} ${r.nom}` : '—'; })()
                : '⚠️ Non défini'}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            {commandeActive.statut !== 'expediee' && (
              <button style={{ ...styleBtnSecondary, fontSize: '12px', padding: '6px 14px' }} onClick={() => openModalCommande(commandeActive)}>
                Modifier la commande
              </button>
            )}
          </div>
        </div>

        {/* Bandeau expédition */}
        {commandeActive.statut === 'production_en_cours' && (
          <div style={{
            backgroundColor: '#fff8e1', border: '1px solid #ffc107', borderRadius: '12px',
            padding: '16px 22px', marginBottom: '24px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '22px' }}>🚚</span>
              <div>
                <div style={{ fontWeight: '700', fontSize: '14px', color: '#856404' }}>Tous les produits sont en fabrication !</div>
                <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '2px' }}>La commande sera expédiée prochainement.</div>
              </div>
            </div>
            <button
              onClick={() => { setNumeroSuivi(''); setErreurExpedition(''); setShowModalExpedition(true); }}
              style={{ padding: '10px 22px', backgroundColor: '#ffc107', color: '#212529', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '14px', whiteSpace: 'nowrap' }}
            >
              📦 Marquer comme expédiée
            </button>
          </div>
        )}
        {commandeActive.statut === 'expediee' && (
          <div style={{
            backgroundColor: '#f0fff4', border: '1px solid #28a745', borderRadius: '12px',
            padding: '16px 22px', marginBottom: '24px',
            display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap'
          }}>
            <span style={{ fontSize: '22px' }}>✅</span>
            <div>
              <div style={{ fontWeight: '700', fontSize: '14px', color: '#155724' }}>Commande expédiée</div>
              <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '2px' }}>
                N° suivi : <strong style={{ color: '#212529' }}>{commandeActive.numero_suivi}</strong>
                {commandeActive.date_expedition && (
                  <span> — le {new Date(commandeActive.date_expedition).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>
                )}
                {commandeActive.numero_suivi && (
                  <a
                    href={`https://www.laposte.fr/outils/suivre-vos-envois?code=${commandeActive.numero_suivi}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: '12px', fontSize: '13px', color: '#003189', fontWeight: '600', textDecoration: 'none' }}
                  >
                    📬 Suivre sur La Poste →
                  </a>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Lignes produit */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#212529' }}>
            Lignes produit ({lignes.length})
          </h3>
          {commandeActive.statut !== 'expediee' && (
            <button style={styleBtnPrimary} onClick={() => openModalLigne()}>
              + Ajouter un produit
            </button>
          )}
        </div>

        {loadingLignes ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px' }}>Chargement...</div>
        ) : lignes.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px', border: '2px dashed #e9ecef', borderRadius: '12px' }}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>📋</div>
            <div style={{ fontWeight: '600' }}>Aucun produit ajouté</div>
            <div style={{ fontSize: '13px', marginTop: '4px' }}>Cliquez sur "+ Ajouter un produit" pour commencer.</div>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
              <thead>
                <tr>
                  {['Produit', 'Pilote', 'Option', 'Qté', 'Opérateur', 'Statut', 'Actions'].map(h => (
                    <th key={h} style={{
                      textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#adb5bd',
                      textTransform: 'uppercase', padding: '6px 12px', letterSpacing: '0.5px'
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {lignes.map(ligne => (
                  <tr key={ligne.id}>
                    {[
                      <td key="prod" style={tdStyle}><span style={{ fontWeight: '600', color: '#212529' }}>{ligne.produit_nom}</span></td>,
                      <td key="pil" style={tdStyle}>{ligne.ffm_pilotes ? `${ligne.ffm_pilotes.prenom} ${ligne.ffm_pilotes.nom}` : '—'}</td>,
                      <td key="opt" style={tdStyle}>
                        {ligne.option_valeur ? (
                          <span style={{ backgroundColor: '#e8f0fe', color: '#003189', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' }}>
                            {ligne.option_valeur}
                          </span>
                        ) : '—'}
                      </td>,
                      <td key="qty" style={{ ...tdStyle, textAlign: 'center' }}>{ligne.quantite}</td>,
                      <td key="op" style={tdStyle}>{ligne.operateur_nom || '—'}</td>,
                      <td key="st" style={tdStyle}>{badgeStatutLigne(ligne.statut)}</td>,
                      <td key="act" style={tdStyle}>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          {/* Modifier — attente_infos uniquement */}
                          {ligne.statut === 'attente_infos' && (
                            <button style={{ ...styleBtnSecondary, padding: '5px 12px', fontSize: '12px' }}
                              onClick={() => openModalLigne(ligne)}>
                              Modifier
                            </button>
                          )}
                          {/* Infos BAT — logique selon fige et statut */}
                          {ligne.statut !== 'attente_infos' && (() => {
                            const fige = ligne.ffm_bat_infos?.fige;
                            const aDesInfos = !!ligne.ffm_bat_infos;
                            // Dès que le BAT a été uploadé (infos figées) → Suivi BAT à la place
                            if (fige) return null;
                            // Pas encore figé → éditable si bat_a_faire
                            if (ligne.statut === 'bat_a_faire') {
                              return (
                                <button
                                  style={{ padding: '5px 12px', fontSize: '12px', fontWeight: '600', border: '1px solid #6f42c1', borderRadius: '8px', cursor: 'pointer', backgroundColor: 'transparent', color: '#6f42c1' }}
                                  onClick={() => openModalInfosBAT(ligne)}>
                                  {aDesInfos ? 'Modifier infos' : 'Envoyer infos'}
                                </button>
                              );
                            }
                            return null;
                          })()}
                          {/* Envoyer infos — statut attente_infos (aucune infos encore) */}
                          {ligne.statut === 'attente_infos' && (
                            <button
                              style={{ padding: '5px 12px', fontSize: '12px', fontWeight: '600', border: '1px solid #6f42c1', borderRadius: '8px', cursor: 'pointer', backgroundColor: 'transparent', color: '#6f42c1' }}
                              onClick={() => openModalInfosBAT(ligne)}>
                              Envoyer infos
                            </button>
                          )}
                          {/* Upload BAT — bat_a_faire ou bat_attente_validation */}
                          {(ligne.statut === 'bat_a_faire' || ligne.statut === 'bat_attente_validation') && (
                            <button
                              style={{ padding: '5px 12px', fontSize: '12px', fontWeight: '600', border: '1px solid #003189', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#003189', color: '#fff' }}
                              onClick={() => openModalUploadBAT(ligne)}>
                              {ligne.statut === 'bat_attente_validation' ? 'Nouvelle version' : 'Upload BAT'}
                            </button>
                          )}
                          {/* Suivi BAT — dès que le BAT a été uploadé (infos figées ou statut avancé) */}
                          {ligne.statut !== 'attente_infos' && ligne.ffm_bat_infos?.fige && (
                            <button
                              style={{ padding: '5px 12px', fontSize: '12px', fontWeight: '600', border: '1px solid #003189', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#e8f0fe', color: '#003189' }}
                              onClick={() => ouvrirHistorique(ligne)}>
                              📋 Suivi BAT
                            </button>
                          )}
                          {/* Supprimer — attente_infos uniquement */}
                          {ligne.statut === 'attente_infos' && (
                            <button style={styleDanger} onClick={() => handleDeleteLigne(ligne.id)}>
                              ✕
                            </button>
                          )}
                        </div>
                      </td>
                    ]}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ── Modal ligne produit ─────────────────────────────────────────────── */}
        {showModalLigne && (
          <ModalLigne
            formLigne={formLigne}
            setFormLigne={setFormLigne}
            produits={produits}
            pilotes={pilotes}
            operateursBack={operateursBack}
            produitSelectionne={produitSelectionne}
            editingLigne={editingLigne}
            erreurLigne={erreurLigne}
            onSubmit={handleSubmitLigne}
            onClose={closeModalLigne}
            styleInput={styleInput}
            styleLabel={styleLabel}
            styleBtnPrimary={styleBtnPrimary}
            styleBtnSecondary={styleBtnSecondary}
          />
        )}

        {/* ── Modal commande (modification) ──────────────────────────────────── */}
        {showModalCommande && (
          <ModalCommande
            formCommande={formCommande}
            setFormCommande={setFormCommande}
            operateursBack={operateursBack}
            editingCommande={editingCommande}
            erreurCommande={erreurCommande}
            onSubmit={handleSubmitCommande}
            onClose={closeModalCommande}
            styleInput={styleInput}
            styleLabel={styleLabel}
            styleBtnPrimary={styleBtnPrimary}
            styleBtnSecondary={styleBtnSecondary}
          />
        )}

        {/* ── Modal Envoyer infos BAT ─────────────────────────────────────────── */}
        {showModalInfosBAT && (
          <ModalInfosBAT
            ligne={ligneInfosBAT}
            form={formInfosBAT}
            setForm={setFormInfosBAT}
            fichiers={fichiersInfosBAT}
            setFichiers={setFichiersInfosBAT}
            piecesJointesExistantes={piecesJointesExistantes}
            readOnly={readOnlyInfosBAT}
            erreur={erreurInfosBAT}
            submitting={submittingInfosBAT}
            onSubmit={handleSubmitInfosBAT}
            onClose={closeModalInfosBAT}
            styleInput={styleInput}
            styleLabel={styleLabel}
            styleBtnPrimary={styleBtnPrimary}
            styleBtnSecondary={styleBtnSecondary}
          />
        )}

        {/* ── Modal Upload BAT ────────────────────────────────────────────────── */}
        {showModalUploadBAT && (
          <ModalUploadBAT
            ligne={ligneUploadBAT}
            fichier={fichierBAT}
            setFichier={setFichierBAT}
            erreur={erreurUploadBAT}
            uploading={uploadingBAT}
            onSubmit={handleSubmitUploadBAT}
            onClose={closeModalUploadBAT}
            styleInput={styleInput}
            styleLabel={styleLabel}
            styleBtnPrimary={styleBtnPrimary}
            styleBtnSecondary={styleBtnSecondary}
          />
        )}

        {/* ── Modal Historique BAT ────────────────────────────────────────────── */}
        {showModalHistorique && (
          <ModalHistorique
            ligne={ligneHistorique}
            historique={historique}
            loading={loadingHistorique}
            onClose={fermerHistorique}
            styleBtnSecondary={styleBtnSecondary}
          />
        )}

        {/* ── Modal Expédition ────────────────────────────────────────────────── */}
        {showModalExpedition && (
          <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '440px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
              <h3 style={{ margin: '0 0 6px', fontSize: '18px', fontWeight: '700', color: '#212529' }}>📦 Expédition</h3>
              <p style={{ margin: '0 0 24px', fontSize: '13px', color: '#6c757d' }}>{commandeActive.nom}</p>
              <label style={styleLabel}>Numéro de suivi <span style={{ color: '#dc3545' }}>*</span></label>
              <input
                type="text"
                value={numeroSuivi}
                onChange={e => { setNumeroSuivi(e.target.value); setErreurExpedition(''); }}
                placeholder="Ex : 1Z999AA10123456784"
                style={{ ...styleInput, marginBottom: '6px' }}
                autoFocus
                onKeyDown={e => e.key === 'Enter' && handleExpedier()}
              />
              {erreurExpedition && <div style={{ color: '#dc3545', fontSize: '13px', marginBottom: '16px' }}>{erreurExpedition}</div>}
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                <button
                  onClick={handleExpedier}
                  disabled={submittingExpedition}
                  style={{ flex: 1, padding: '12px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '15px', opacity: submittingExpedition ? 0.7 : 1 }}
                >
                  {submittingExpedition ? 'Enregistrement...' : '✅ Confirmer l\'expédition'}
                </button>
                <button
                  onClick={() => setShowModalExpedition(false)}
                  disabled={submittingExpedition}
                  style={{ ...styleBtnSecondary, padding: '12px 20px' }}
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  // VUE LISTE DES COMMANDES
  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div>
      {/* En-tête */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#212529' }}>Commandes FFM</h2>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6c757d' }}>
            {commandes.length} commande{commandes.length > 1 ? 's' : ''}
          </p>
        </div>
        <button style={styleBtnPrimary} onClick={() => openModalCommande()}>+ Nouvelle commande</button>
      </div>

      {/* Liste */}
      {loading ? (
        <div style={{ textAlign: 'center', color: '#6c757d', padding: '60px' }}>Chargement...</div>
      ) : commandes.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#6c757d', padding: '60px' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>📦</div>
          <div style={{ fontSize: '16px', fontWeight: '600' }}>Aucune commande</div>
          <div style={{ fontSize: '13px', marginTop: '6px' }}>Cliquez sur "+ Nouvelle commande" pour commencer.</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {commandes.map(commande => {
            const nbLignes = commande.ffm_lignes_produit?.length || 0;
            const nbValides = commande.ffm_lignes_produit?.filter(l => l.statut === 'bat_valide').length || 0;
            return (
              <div
                key={commande.id}
                style={{
                  backgroundColor: '#ffffff', borderRadius: '12px', border: '1px solid #e9ecef',
                  padding: '18px 22px', cursor: 'pointer', transition: 'box-shadow 0.15s',
                  display: 'flex', alignItems: 'center', gap: '16px'
                }}
                onClick={() => ouvrirCommande(commande)}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,49,137,0.1)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                {/* Infos principales */}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                    <span style={{ fontWeight: '700', fontSize: '16px', color: '#212529' }}>{commande.nom}</span>
                    {badgeStatutCommande(commande.statut)}
                  </div>
                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '13px', color: '#6c757d' }}>🏁 {commande.nom_course}</span>
                    {commande.date_course && (
                      <span style={{ fontSize: '13px', color: '#6c757d' }}>📅 {formatDate(commande.date_course)}</span>
                    )}
                    {commande.adresse_ville && (
                      <span style={{ fontSize: '13px', color: '#6c757d' }}>📍 {commande.adresse_ville}</span>
                    )}
                  </div>
                </div>

                {/* Compteur lignes */}
                <div style={{ textAlign: 'center', minWidth: '80px' }}>
                  <div style={{ fontSize: '22px', fontWeight: '700', color: '#003189' }}>{nbLignes}</div>
                  <div style={{ fontSize: '11px', color: '#adb5bd', fontWeight: '600' }}>
                    produit{nbLignes > 1 ? 's' : ''}
                  </div>
                  {nbLignes > 0 && (
                    <div style={{ fontSize: '11px', color: '#28a745', marginTop: '2px' }}>
                      {nbValides}/{nbLignes} validé{nbValides > 1 ? 's' : ''}
                    </div>
                  )}
                </div>

                {/* Flèche */}
                <div style={{ color: '#adb5bd', fontSize: '20px', marginLeft: '8px' }}>›</div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Modal commande ──────────────────────────────────────────────────── */}
      {showModalCommande && (
        <ModalCommande
          formCommande={formCommande}
          setFormCommande={setFormCommande}
          operateursBack={operateursBack}
          editingCommande={editingCommande}
          erreurCommande={erreurCommande}
          onSubmit={handleSubmitCommande}
          onClose={closeModalCommande}
          styleInput={styleInput}
          styleLabel={styleLabel}
          styleBtnPrimary={styleBtnPrimary}
          styleBtnSecondary={styleBtnSecondary}
        />
      )}
    </div>
  );
}

// ─── Style TD ─────────────────────────────────────────────────────────────────
const tdStyle = {
  padding: '12px',
  backgroundColor: '#ffffff',
  fontSize: '13px',
  color: '#495057',
  borderTop: '1px solid #f1f3f5',
  borderBottom: '1px solid #f1f3f5',
  verticalAlign: 'middle'
};

const styleDanger = {
  padding: '7px 14px', backgroundColor: 'transparent', color: '#dc3545',
  border: '1px solid #dc3545', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '500'
};

// ─── Modal Commande ───────────────────────────────────────────────────────────
function ModalCommande({ formCommande, setFormCommande, operateursBack, editingCommande, erreurCommande, onSubmit, onClose, styleInput, styleLabel, styleBtnPrimary, styleBtnSecondary }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: '#ffffff', borderRadius: '16px', padding: '32px',
        width: '100%', maxWidth: '560px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        maxHeight: '90vh', overflowY: 'auto'
      }}>
        <h3 style={{ margin: '0 0 24px', fontSize: '18px', fontWeight: '700', color: '#212529' }}>
          {editingCommande ? 'Modifier la commande' : 'Nouvelle commande'}
        </h3>
        <form onSubmit={onSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={styleLabel}>Référence de la commande *</label>
            <input style={styleInput} type="text" placeholder="Ex : Équipe de France Vitesse 2026"
              value={formCommande.nom} autoFocus
              onChange={e => setFormCommande(p => ({ ...p, nom: e.target.value }))} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={styleLabel}>Nom de la course *</label>
            <input style={styleInput} type="text" placeholder="Ex : Grand Prix de France Moto"
              value={formCommande.nom_course}
              onChange={e => setFormCommande(p => ({ ...p, nom_course: e.target.value }))} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={styleLabel}>Date de la course <span style={{ color: '#adb5bd', fontWeight: '400' }}>(optionnel)</span></label>
            <input style={styleInput} type="date"
              value={formCommande.date_course}
              onChange={e => setFormCommande(p => ({ ...p, date_course: e.target.value }))} />
          </div>
          <div style={{ marginBottom: '8px' }}>
            <label style={styleLabel}>Adresse de livraison <span style={{ color: '#adb5bd', fontWeight: '400' }}>(optionnel)</span></label>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <input style={styleInput} type="text" placeholder="Entreprise / Club"
              value={formCommande.adresse_entreprise}
              onChange={e => setFormCommande(p => ({ ...p, adresse_entreprise: e.target.value }))} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
            <input style={styleInput} type="text" placeholder="Prénom"
              value={formCommande.adresse_prenom}
              onChange={e => setFormCommande(p => ({ ...p, adresse_prenom: e.target.value }))} />
            <input style={styleInput} type="text" placeholder="Nom"
              value={formCommande.adresse_nom}
              onChange={e => setFormCommande(p => ({ ...p, adresse_nom: e.target.value }))} />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <input style={styleInput} type="text" placeholder="Rue"
              value={formCommande.adresse_rue}
              onChange={e => setFormCommande(p => ({ ...p, adresse_rue: e.target.value }))} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px', marginBottom: '24px' }}>
            <input style={styleInput} type="text" placeholder="Code postal"
              value={formCommande.adresse_cp}
              onChange={e => setFormCommande(p => ({ ...p, adresse_cp: e.target.value }))} />
            <input style={styleInput} type="text" placeholder="Ville"
              value={formCommande.adresse_ville}
              onChange={e => setFormCommande(p => ({ ...p, adresse_ville: e.target.value }))} />
          </div>
          <div style={{ marginBottom: '24px', paddingTop: '8px', borderTop: '1px solid #e9ecef' }}>
            <label style={{ ...styleLabel, marginTop: '8px' }}>
              Responsable validation finale <span style={{ color: '#dc3545' }}>*</span>
              <span style={{ color: '#adb5bd', fontWeight: '400', fontSize: '12px', marginLeft: '6px' }}>Effectue la 2ème validation des BAT</span>
            </label>
            <select style={{ ...styleInput, backgroundColor: '#ffffff' }}
              value={formCommande.responsable_validation_id}
              onChange={e => setFormCommande(p => ({ ...p, responsable_validation_id: e.target.value }))}>
              <option value="">— Sélectionner un opérateur —</option>
              {operateursBack.map(op => (
                <option key={op.id} value={op.id}>{op.prenom} {op.nom}</option>
              ))}
            </select>
          </div>
          {erreurCommande && (
            <div style={{ padding: '10px 14px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
              {erreurCommande}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button type="button" style={styleBtnSecondary} onClick={onClose}>Annuler</button>
            <button type="submit" style={styleBtnPrimary}>
              {editingCommande ? 'Enregistrer' : 'Créer la commande'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── Modal Ligne Produit ──────────────────────────────────────────────────────
function ModalLigne({ formLigne, setFormLigne, produits, pilotes, operateursBack, produitSelectionne, editingLigne, erreurLigne, onSubmit, onClose, styleInput, styleLabel, styleBtnPrimary, styleBtnSecondary }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: '#ffffff', borderRadius: '16px', padding: '32px',
        width: '100%', maxWidth: '500px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        maxHeight: '90vh', overflowY: 'auto'
      }}>
        <h3 style={{ margin: '0 0 24px', fontSize: '18px', fontWeight: '700', color: '#212529' }}>
          {editingLigne ? 'Modifier la ligne' : 'Ajouter un produit'}
        </h3>
        <form onSubmit={onSubmit}>
          {/* Produit */}
          <div style={{ marginBottom: '16px' }}>
            <label style={styleLabel}>Produit *</label>
            <select style={{ ...styleInput, backgroundColor: '#ffffff' }}
              value={formLigne.produit_id}
              onChange={e => setFormLigne(p => ({ ...p, produit_id: e.target.value, option_valeur: '' }))}>
              <option value="">— Sélectionner un produit —</option>
              {produits.map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}
            </select>
          </div>

          {/* Option du produit (si applicable) */}
          {produitSelectionne?.option_nom && (
            <div style={{ marginBottom: '16px' }}>
              <label style={styleLabel}>{produitSelectionne.option_nom} *</label>
              <select style={{ ...styleInput, backgroundColor: '#ffffff' }}
                value={formLigne.option_valeur}
                onChange={e => setFormLigne(p => ({ ...p, option_valeur: e.target.value }))}>
                <option value="">— Sélectionner —</option>
                {(produitSelectionne.option_valeurs || []).map(v => <option key={v} value={v}>{v}</option>)}
              </select>
            </div>
          )}

          {/* Pilote */}
          <div style={{ marginBottom: '16px' }}>
            <label style={styleLabel}>Pilote *</label>
            <select style={{ ...styleInput, backgroundColor: '#ffffff' }}
              value={formLigne.pilote_id}
              onChange={e => setFormLigne(p => ({ ...p, pilote_id: e.target.value }))}>
              <option value="">— Sélectionner un pilote —</option>
              {pilotes.map(p => <option key={p.id} value={p.id}>{p.prenom} {p.nom}</option>)}
            </select>
          </div>

          {/* Opérateur FFM responsable */}
          <div style={{ marginBottom: '16px' }}>
            <label style={styleLabel}>Opérateur FFM responsable <span style={{ color: '#adb5bd', fontWeight: '400' }}>(optionnel)</span></label>
            <select style={{ ...styleInput, backgroundColor: '#ffffff' }}
              value={formLigne.operateur_ffm_id}
              onChange={e => {
                const op = operateursBack.find(o => o.id === e.target.value);
                setFormLigne(p => ({
                  ...p,
                  operateur_ffm_id: e.target.value,
                  operateur_nom: op ? `${op.prenom} ${op.nom}` : ''
                }));
              }}>
              <option value="">— Sélectionner un opérateur —</option>
              {operateursBack.map(op => (
                <option key={op.id} value={op.id}>{op.prenom} {op.nom}</option>
              ))}
            </select>
          </div>

          {/* Quantité */}
          <div style={{ marginBottom: '24px' }}>
            <label style={styleLabel}>Quantité *</label>
            <input style={{ ...styleInput, maxWidth: '120px' }} type="number" min="1"
              value={formLigne.quantite}
              onChange={e => setFormLigne(p => ({ ...p, quantite: e.target.value }))} />
          </div>

          {erreurLigne && (
            <div style={{ padding: '10px 14px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
              {erreurLigne}
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button type="button" style={styleBtnSecondary} onClick={onClose}>Annuler</button>
            <button type="submit" style={styleBtnPrimary}>
              {editingLigne ? 'Enregistrer' : 'Ajouter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── Modal Infos BAT ──────────────────────────────────────────────────────────
function ModalInfosBAT({ ligne, form, setForm, fichiers, setFichiers, piecesJointesExistantes, readOnly, erreur, submitting, onSubmit, onClose, styleInput, styleLabel, styleBtnPrimary, styleBtnSecondary }) {
  const ajouterFichiers = (e) => {
    const nouveaux = Array.from(e.target.files);
    setFichiers(prev => [...prev, ...nouveaux]);
    e.target.value = '';
  };

  const supprimerFichier = (index) => {
    setFichiers(prev => prev.filter((_, i) => i !== index));
  };

  const nomFichier = (url) => {
    try { return decodeURIComponent(url.split('/').pop().replace(/^\d+_/, '')); }
    catch { return url.split('/').pop(); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '560px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' }}>

        {/* En-tête */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '6px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#212529' }}>
            {readOnly ? 'Infos transmises au graphiste' : 'Infos pour le graphiste'}
          </h3>
          {readOnly && (
            <span style={{ fontSize: '11px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', backgroundColor: '#d4edda', color: '#155724', border: '1px solid #28a745', whiteSpace: 'nowrap', marginLeft: '10px' }}>
              Figé — BAT en cours
            </span>
          )}
        </div>
        <p style={{ margin: '0 0 24px', fontSize: '13px', color: '#6c757d' }}>
          {ligne?.produit_nom} — {ligne?.ffm_pilotes ? `${ligne.ffm_pilotes.prenom} ${ligne.ffm_pilotes.nom}` : ''}
        </p>

        {/* ── MODE LECTURE SEULE ──────────────────────────────────────────── */}
        {readOnly ? (
          <div>
            {/* Description */}
            <div style={{ marginBottom: '20px' }}>
              <label style={styleLabel}>Description / instructions</label>
              <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '8px', padding: '14px', fontSize: '14px', color: '#212529', whiteSpace: 'pre-wrap', lineHeight: '1.6', minHeight: '80px' }}>
                {form.description || <span style={{ color: '#adb5bd' }}>Aucune description.</span>}
              </div>
            </div>

            {/* Pièces jointes existantes */}
            {piecesJointesExistantes.length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <label style={styleLabel}>Pièces jointes ({piecesJointesExistantes.length})</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {piecesJointesExistantes.map((url, i) => (
                    <a
                      key={i}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: '#e8f0fe', borderRadius: '8px', padding: '10px 14px', textDecoration: 'none', color: '#003189', fontWeight: '500', fontSize: '13px' }}
                    >
                      <span style={{ fontSize: '18px' }}>📄</span>
                      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nomFichier(url)}</span>
                      <span style={{ fontSize: '11px', color: '#6c757d', flexShrink: 0 }}>Télécharger →</span>
                    </a>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button style={styleBtnSecondary} onClick={onClose}>Fermer</button>
            </div>
          </div>

        ) : (
        /* ── MODE ÉDITION ───────────────────────────────────────────────── */
          <form onSubmit={onSubmit}>
            {/* Description */}
            <div style={{ marginBottom: '20px' }}>
              <label style={styleLabel}>Description / instructions *</label>
              <textarea
                style={{ ...styleInput, minHeight: '120px', resize: 'vertical', fontFamily: 'inherit' }}
                placeholder="Couleurs, numéro de dossard, texte à intégrer, contraintes particulières..."
                value={form.description}
                autoFocus
                onChange={e => setForm(p => ({ ...p, description: e.target.value }))}
              />
            </div>

            {/* Pièces jointes déjà enregistrées */}
            {piecesJointesExistantes.length > 0 && (
              <div style={{ marginBottom: '16px' }}>
                <label style={styleLabel}>Pièces jointes déjà envoyées</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {piecesJointesExistantes.map((url, i) => (
                    <a key={i} href={url} target="_blank" rel="noopener noreferrer"
                      style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#e8f0fe', borderRadius: '8px', padding: '8px 12px', textDecoration: 'none', color: '#003189', fontSize: '13px', fontWeight: '500' }}>
                      <span>📄</span>
                      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nomFichier(url)}</span>
                      <span style={{ fontSize: '11px', color: '#6c757d' }}>Voir →</span>
                    </a>
                  ))}
                </div>
              </div>
            )}

            {/* Ajouter de nouvelles pièces jointes */}
            <div style={{ marginBottom: '24px' }}>
              <label style={styleLabel}>
                {piecesJointesExistantes.length > 0 ? 'Ajouter des pièces jointes' : 'Pièces jointes'}
                <span style={{ color: '#adb5bd', fontWeight: '400' }}> (optionnel)</span>
              </label>
              <div
                style={{ border: '2px dashed #dee2e6', borderRadius: '10px', padding: '16px', textAlign: 'center', cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                onClick={() => document.getElementById('input-infos-bat-files').click()}
              >
                <div style={{ fontSize: '20px', marginBottom: '4px' }}>📎</div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>Cliquez pour ajouter des fichiers</div>
                <div style={{ fontSize: '11px', color: '#adb5bd', marginTop: '2px' }}>PDF, PNG, JPG, SVG, AI — max 20 Mo par fichier</div>
              </div>
              <input
                id="input-infos-bat-files"
                type="file"
                multiple
                accept=".pdf,.png,.jpg,.jpeg,.svg,.ai,.eps"
                style={{ display: 'none' }}
                onChange={ajouterFichiers}
              />
              {fichiers.length > 0 && (
                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {fichiers.map((f, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#e8f0fe', borderRadius: '8px', padding: '8px 12px' }}>
                      <span style={{ fontSize: '13px', color: '#003189', fontWeight: '500' }}>📄 {f.name}</span>
                      <button type="button" onClick={() => supprimerFichier(i)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc3545', fontSize: '16px', padding: '0 4px' }}>✕</button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {erreur && (
              <div style={{ padding: '10px 14px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
                {erreur}
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button type="button" style={styleBtnSecondary} onClick={onClose} disabled={submitting}>Annuler</button>
              <button type="submit" style={{ ...styleBtnPrimary, backgroundColor: '#6f42c1', opacity: submitting ? 0.7 : 1 }} disabled={submitting}>
                {submitting ? 'Enregistrement...' : 'Enregistrer les infos'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

// ─── Modal Upload BAT ─────────────────────────────────────────────────────────
function ModalUploadBAT({ ligne, fichier, setFichier, erreur, uploading, onSubmit, onClose, styleLabel, styleBtnPrimary, styleBtnSecondary }) {
  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '480px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <h3 style={{ margin: '0 0 6px', fontSize: '18px', fontWeight: '700', color: '#212529' }}>Upload BAT</h3>
        <p style={{ margin: '0 0 24px', fontSize: '13px', color: '#6c757d' }}>
          {ligne?.produit_nom} — {ligne?.ffm_pilotes ? `${ligne.ffm_pilotes.prenom} ${ligne.ffm_pilotes.nom}` : ''}
        </p>
        <form onSubmit={onSubmit}>
          <div style={{ marginBottom: '24px' }}>
            <label style={styleLabel}>Fichier BAT *</label>
            <div style={{
              border: '2px dashed #dee2e6', borderRadius: '12px', padding: '32px',
              textAlign: 'center', backgroundColor: '#f8f9fa', cursor: 'pointer'
            }}
              onClick={() => document.getElementById('input-bat-file').click()}
            >
              {fichier ? (
                <div>
                  <div style={{ fontSize: '28px', marginBottom: '8px' }}>📄</div>
                  <div style={{ fontWeight: '600', color: '#212529', fontSize: '14px' }}>{fichier.name}</div>
                  <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                    {(fichier.size / 1024 / 1024).toFixed(2)} Mo
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ fontSize: '32px', marginBottom: '8px' }}>📁</div>
                  <div style={{ fontWeight: '600', color: '#495057', fontSize: '14px' }}>Cliquez pour sélectionner</div>
                  <div style={{ fontSize: '12px', color: '#adb5bd', marginTop: '4px' }}>PDF, PNG, JPG, AI — max 20 Mo</div>
                </div>
              )}
            </div>
            <input
              id="input-bat-file"
              type="file"
              accept=".pdf,.png,.jpg,.jpeg,.ai,.eps"
              style={{ display: 'none' }}
              onChange={e => setFichier(e.target.files[0] || null)}
            />
          </div>
          {erreur && (
            <div style={{ padding: '10px 14px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
              {erreur}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button type="button" style={styleBtnSecondary} onClick={onClose}>Annuler</button>
            <button type="submit" style={{ ...styleBtnPrimary, opacity: uploading ? 0.7 : 1 }} disabled={uploading}>
              {uploading ? 'Upload en cours...' : 'Uploader le BAT'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── Libellés événements historique ──────────────────────────────────────────
const EVENEMENTS = {
  infos_envoyees:          { label: 'Infos envoyées',             color: '#6f42c1', bg: '#f0e6ff' },
  bat_uploade:             { label: 'BAT uploadé',                color: '#003189', bg: '#e8f0fe' },
  bat_valide_pilote:       { label: 'BAT validé (pilote)',        color: '#155724', bg: '#d4edda' },
  bat_refuse_pilote:       { label: 'BAT refusé (pilote)',        color: '#721c24', bg: '#f8d7da' },
  bat_valide_operateur:    { label: 'BAT validé (opérateur)',     color: '#155724', bg: '#d4edda' },
  bat_refuse_operateur:    { label: 'BAT refusé (opérateur)',     color: '#721c24', bg: '#f8d7da' },
  bat_valide_final:        { label: 'BAT validé définitivement',  color: '#ffffff', bg: '#003189' },
};

// ─── Modal Historique BAT ─────────────────────────────────────────────────────
function ModalHistorique({ ligne, historique, loading, onClose, styleBtnSecondary }) {
  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '580px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', maxHeight: '85vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
          <div>
            <h3 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: '700', color: '#212529' }}>Suivi BAT</h3>
            <p style={{ margin: 0, fontSize: '13px', color: '#6c757d' }}>
              {ligne?.produit_nom} — {ligne?.ffm_pilotes ? `${ligne.ffm_pilotes.prenom} ${ligne.ffm_pilotes.nom}` : ''}
            </p>
          </div>
          <button style={styleBtnSecondary} onClick={onClose}>Fermer</button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px' }}>Chargement...</div>
        ) : historique.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px' }}>Aucun événement enregistré.</div>
        ) : (
          <div style={{ position: 'relative' }}>
            {/* Ligne verticale timeline */}
            <div style={{ position: 'absolute', left: '15px', top: '8px', bottom: '8px', width: '2px', backgroundColor: '#e9ecef' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {historique.map((evt, i) => {
                const ev = EVENEMENTS[evt.type_evenement] || { label: evt.type_evenement, color: '#495057', bg: '#f8f9fa' };
                const d = new Date(evt.date_evenement);
                const dateStr = d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
                const heureStr = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
                return (
                  <div key={evt.id} style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                    {/* Pastille */}
                    <div style={{
                      width: '32px', height: '32px', borderRadius: '50%', backgroundColor: ev.bg,
                      border: `2px solid ${ev.color}`, flexShrink: 0, zIndex: 1,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '12px', fontWeight: '700', color: ev.color
                    }}>
                      {i + 1}
                    </div>
                    {/* Contenu */}
                    <div style={{ flex: 1, backgroundColor: '#f8f9fa', borderRadius: '10px', padding: '12px 16px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                        <span style={{ backgroundColor: ev.bg, color: ev.color, fontSize: '11px', fontWeight: '700', padding: '2px 8px', borderRadius: '12px' }}>
                          {ev.label}
                        </span>
                        <span style={{ fontSize: '11px', color: '#adb5bd' }}>{dateStr} à {heureStr}</span>
                      </div>
                      {evt.auteur && (
                        <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Par : {evt.auteur}</div>
                      )}
                      {evt.commentaire && (
                        <div style={{ fontSize: '13px', color: '#495057', marginTop: '6px', whiteSpace: 'pre-wrap' }}>{evt.commentaire}</div>
                      )}
                      {evt.pieces_jointes && evt.pieces_jointes.length > 0 && (
                        <div style={{ marginTop: '10px' }}>
                          <div style={{ fontSize: '11px', fontWeight: '700', color: '#adb5bd', textTransform: 'uppercase', marginBottom: '6px' }}>
                            Fichiers joints ({evt.pieces_jointes.length})
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {evt.pieces_jointes.map((url, idx) => {
                              const nomFichier = decodeURIComponent(url.split('/').pop().replace(/\?.*$/, ''));
                              const ext = nomFichier.split('.').pop().toLowerCase();
                              const icone = ['jpg','jpeg','png','gif','svg','webp'].includes(ext) ? '🖼️'
                                : ext === 'pdf' ? '📄'
                                : ['ai','eps','psb','psd'].includes(ext) ? '🎨'
                                : '📎';
                              return (
                                <a
                                  key={idx}
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                                    fontSize: '12px', color: '#003189', fontWeight: '500',
                                    textDecoration: 'none', padding: '4px 10px',
                                    backgroundColor: '#e8f0fe', borderRadius: '6px',
                                    width: 'fit-content'
                                  }}
                                >
                                  {icone} {nomFichier} ↓
                                </a>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      {evt.ffm_bat_versions?.fichier_url && (
                        <a
                          href={evt.ffm_bat_versions.fichier_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'inline-block', marginTop: '8px', fontSize: '12px', color: '#003189', fontWeight: '600', textDecoration: 'none' }}
                        >
                          Voir BAT v{evt.ffm_bat_versions.numero_version} →
                        </a>
                      )}
                      {/* Liens tokens pilote/opérateur/responsable sur les événements bat_uploade */}
                      {evt.type_evenement === 'bat_uploade' && evt.ffm_bat_versions?.ffm_bat_tokens?.length > 0 && (
                        <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          {['pilote', 'operateur', 'responsable'].map(type => {
                            const tok = evt.ffm_bat_versions.ffm_bat_tokens.find(t => t.type === type);
                            if (!tok) return null;
                            const lien = `${window.location.origin}/ffm/bat/${tok.token}`;
                            const statutIcon = tok.statut === 'valide' ? '✅'
                              : tok.statut === 'refuse' ? '❌'
                              : tok.bloque ? '🔒'
                              : '⏳';
                            const statutLabel = type === 'pilote'
                              ? 'Consultation'
                              : tok.statut === 'valide' ? 'Validé'
                              : tok.statut === 'refuse' ? 'Refusé'
                              : tok.bloque ? 'En attente opérateur'
                              : 'En attente';
                            const emoji = type === 'pilote' ? '🧑‍✈️' : type === 'operateur' ? '👷' : '🎖️';
                            const label = type === 'pilote' ? 'Pilote'
                              : type === 'operateur' ? 'Opérateur FFM'
                              : 'Responsable validation';
                            return (
                              <div key={type} style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                <span style={{ fontSize: '12px', color: '#495057', minWidth: '220px' }}>
                                  {emoji} <strong>{label}</strong> : {tok.nom_destinataire} — {statutIcon} {statutLabel}
                                </span>
                                <a
                                  href={lien}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: '11px', padding: '3px 10px', backgroundColor: '#e8f0fe', border: '1px solid #c5d3f5', borderRadius: '6px', color: '#003189', textDecoration: 'none', fontWeight: '600' }}
                                >
                                  Ouvrir →
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FFMCommandes;
